"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createAMSClient_1 = require("./createAMSClient");
var FramedlessClient_1 = require("./FramedlessClient");
var FramedClient_1 = require("./FramedClient");
exports.default = createAMSClient_1.default;
(function () {
    if (typeof window === undefined) {
        throw new Error("window object not found");
    }
    // Check existence of global objects to avoid overwrite/clashing
    if (!("Microsoft" in window)) {
        window.Microsoft = {};
    }
    if (!("CRM" in window.Microsoft)) {
        window.Microsoft.CRM = {};
    }
    if (!("Omnichannel" in window.Microsoft.CRM)) {
        window.Microsoft.CRM.Omnichannel = {};
    }
    if (!("AMSClient" in window.Microsoft.CRM.Omnichannel)) {
        window.Microsoft.CRM.Omnichannel.AMS = {
            SDK: {
                createAMSClient: createAMSClient_1.default,
                FramedClient: FramedClient_1.default,
                FramedlessClient: FramedlessClient_1.default,
            }
        };
    }
})();
//# sourceMappingURL=index.js.map